import { logger } from '@damofire/data-commons';
import { Remote, wrap } from 'comlink';
import { Observer, Subject } from 'rxjs';
import { WarehouseSyncStepContextEvent, WarehouseSyncStepTask, WarehouseSyncStepTaskContext } from '../executors';
import { executeWorker, WarehouseSyncStepWorkerFactory } from './steps-utils';
import { WarehouseLayoutTextStepsWorker } from '../workers/warehouse-layout-text-steps.worker';

class WarehouseLayoutTextsSyncStepTask implements WarehouseSyncStepWorkerFactory<WarehouseLayoutTextStepsWorker> {
  async createWorker(environment: any): Promise<[Worker, WarehouseLayoutTextStepsWorker | Remote<WarehouseLayoutTextStepsWorker>]> {
    if (environment.appConfig.watson.useWebworkers) {
      const worker = new Worker(new URL('../workers/warehouse-layout-text-steps.worker', import.meta.url), { type: 'module' });
      const workerProxy = wrap<typeof WarehouseLayoutTextStepsWorker>(worker);
      const workerService = await new workerProxy();
      return [worker, workerService];
    }

    return [null, new WarehouseLayoutTextStepsWorker()];
  }
}

export class WarehouseDownloadLayoutTextsSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `DOWN_LAYOUT_TEXTS_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing download layout texts sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseLayoutTextsSyncStepTask(), taskBreaker);
  }
}

export class WarehouseCleanLayoutTextsSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `CLEAN_LAYOUT_TEXTS_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing clean layout texts sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseLayoutTextsSyncStepTask(), taskBreaker);
  }
}

export class WarehousePushLayoutTextsSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `PUSH_LAYOUT_TEXTS_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing push layout texts sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseLayoutTextsSyncStepTask(), taskBreaker);
  }
}
